import { takeLatest } from 'redux-saga'
import { call, put, select } from 'redux-saga/effects'
import { createProjectSelector } from 'selectors'
import { deviceCountSelector } from 'selectors/components'
import createDocumentSaga from 'sagas/createDocumentSaga'
import initialProject from 'helpers/projects/initialProject'
import clearMapComponents from 'helpers/map/clearMapComponents'
import { addProjectAction, expandProjectAction, updateProjectAction } from 'actions/projectActions'
import { clearCamerasAction } from 'actions/cameraActions'
import { CREATE_PROJECT } from 'actions/projectActionTypes'
import { notifyHoneybadgerAction, waitForMapIdleAction } from 'actions/applicationActions'

/** Add a project and then switch to it */
export function * createProject(action) {
  try {
    const { cameras, map, projects, manufacturerSpecific, permalink } = yield select(createProjectSelector)

    if (manufacturerSpecific) window.history.pushState({}, window.document.title, '/')

    const document = Object.assign({}, initialProject(), map && { zoom: map.zoom, location: map.location })
    const idAndRev = yield call(createDocumentSaga, document)
    const project = { ...document, ...idAndRev }

    if (permalink) return window.location.assign(window.location.origin)

    const deviceCount = yield select(deviceCountSelector)
    yield put(updateProjectAction({ deviceCount }))

    if (map) yield call(clearMapComponents, { map, cameras })

    yield put(clearCamerasAction())
    yield put(waitForMapIdleAction(map.ref))
    yield put(addProjectAction(project))
    yield put(expandProjectAction(project))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for create project action, then call function */
export function * watchCreateProject() {
  yield * takeLatest(CREATE_PROJECT, createProject)
}



// WEBPACK FOOTER //
// ./src/sagas/createProjectSaga.js